import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/ui/Header';

import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';
import Button from '../../components/ui/Button';

const AboutDawaaer = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [activeCircle, setActiveCircle] = useState('all');

  const circles = [
    {
      id: 'literature',
      name: 'دائرة الأدب',
      icon: 'BookOpen',
      color: '#8B6914',
      subtext: 'أدب عربي - أدب مقارن',
      hasChildren: true
    },
    {
      id: 'soul',
      name: 'دائرة النفس',
      icon: 'Heart',
      color: '#7D8471',
      subtext: 'رحلة في أعماق الذات'
    },
    {
      id: 'visuals',
      name: 'دائرة العين',
      icon: 'Eye',
      color: '#D4AF37',
      subtext: 'لأن الرؤية تسبق كل شيء.'
    },
    {
      id: 'sound',
      name: 'دائرة الصوت',
      icon: 'Music',
      color: '#8B7355',
      subtext: 'قسمٌ معني بالصوتيات، كالموسيقى والغناء'
    },
    {
      id: 'philosophy',
      name: 'دائرة العقل',
      icon: 'Brain',
      color: '#6B5B47',
      subtext: 'قسمٌ معنيٌ بالفلسفة. لأن الفلسفة هي الحكمة...'
    },
    {
      id: 'heritage',
      name: 'دائرة التراث',
      icon: 'Landmark',
      color: '#8B4513',
      subtext: 'تأملات لأصحابها'
    },
    {
      id: 'arts',
      name: 'دائرة الفنون',
      icon: 'Palette',
      color: '#A0826D',
      subtext: 'قسمٌ معنيٌ بالفنون البصرية والتشكيلية'
    },
    {
      id: 'language',
      name: 'دائرة اللسان',
      icon: 'MessageSquare',
      color: '#6B8E23',
      subtext: 'قسمٌ معنيٌ باللغة العربية وتراكيبها.'
    },
    {
      id: 'reflections',
      name: 'دائرة الرحلة',
      icon: 'Sparkles',
      color: '#9B7653',
      subtext: 'تأملات شخصية وخواطر روحية'
    },
    {
      id: 'sufism',
      name: 'دائرة الدائرة',
      icon: 'Star',
      color: '#5A5A5A',
      subtext: 'افتح عينك؛ فما ثم إلا وجودٌ مستمر...'
    }];

  const handleFilterChange = (circleId, e) => {
    if (e) {
      e?.preventDefault();
    }
    if (activeCircle === circleId) {
      setActiveCircle('all');
    } else {
      setActiveCircle(circleId);
    }
    navigate('/');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      id: 1,
      number: '1',
      title: 'مساحة آمنة',
      description: 'بيئة داعمة تحفز على الإبداع وحرية التعبير، حيث يمكنك مشاركة أفكارك دون خوف من الأحكام المسبقة أو النقد الهدام.',
      icon: 'Shield'
    },
    {
      id: 2,
      number: '2',
      title: 'تدفق إبداعي',
      description: 'حيث تتلاقى الأفكار وتتشكل الرؤى الجديدة، في مساحة تشجع على التفكير العميق والتعبير الأصيل عن الذات الإبداعية.',
      icon: 'Waves'
    },
    {
      id: 3,
      number: '3',
      title: 'جودة لا كميّة',
      description: 'نركز على المحتوى العميق والهادف، بعيداً عن ضوضاء المنصات السريعة.',
      icon: 'Star'
    },
    {
      id: 4,
      number: '4',
      title: 'مجتمع داعم',
      description: 'انضم إلى مجتمع من المبدعين العرب الذين يؤمنون بقوة الكلمة.',
      icon: 'Users'
    }];


  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <Header />
      {/* Mobile Header Bar */}
      <div className="flex lg:hidden fixed top-0 left-0 right-0 h-16 bg-[#F9F7F2]/95 backdrop-blur-sm z-50 px-4 justify-between items-center pt-20">
        <div className="flex items-center gap-2">
          <Image
            src="/assets/images/header_logo-1769143036795.png"
            alt="شعار دوائر"
            className="h-8 object-contain"
            style={{ filter: 'brightness(0) saturate(100%) invert(61%) sepia(32%) saturate(567%) hue-rotate(358deg) brightness(92%) contrast(87%)' }} />
          <div className="flex flex-col justify-center">
            <h1
              className="font-bold text-[32px]"
              style={{ fontFamily: 'Aref Ruqaa, serif', color: '#C5A059' }}>
              دوائر
            </h1>
            <p
              className="whitespace-nowrap text-xs"
              style={{ color: '#5A5A5A' }}>
              نغرّد داخل السِرب؛ آملين أن تنبُتَ للجميع أجنحة.
            </p>
          </div>
        </div>
        <button
          onClick={() => setIsMobileDrawerOpen(true)}
          className="flex items-center justify-center w-10 h-10"
          aria-label="القائمة">
          <Icon name="Menu" size={24} color="#C5A059" />
        </button>
      </div>

      {/* Mobile Drawer Overlay */}
      {isMobileDrawerOpen &&
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-50"
          onClick={() => setIsMobileDrawerOpen(false)}>
          <div
            className="absolute top-0 right-0 bottom-0 w-80 bg-[#F9F7F2] shadow-2xl overflow-y-auto scrollbar-hide animate-slideInRight"
            onClick={(e) => e?.stopPropagation()}>
            <div className="flex justify-end p-4">
              <button
                onClick={() => setIsMobileDrawerOpen(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-black/5"
                aria-label="إغلاق">
                <Icon name="X" size={24} color="#5A5A5A" />
              </button>
            </div>

            <div className="px-6 py-4 space-y-4 text-center">
              <a href="/" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>الرئيسية</a>
              <a href="/about-dawaaer" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>عن دوائر</a>
              <a href="/about" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>من نحن؟</a>
              <a href="/policy" className="block text-xl font-medium text-[#2C2B29] py-3 text-right" style={{ fontFamily: 'Amiri, serif' }}>سياستنا</a>
            </div>

            <div className="mx-6 my-4 border-t border-[#C5A059]/30" />

            <div className="px-6 py-4">
              <h3 className="text-lg font-bold mb-4 text-right" style={{ fontFamily: 'Aref Ruqaa, serif', color: '#2C2B29' }}>
                دوائر
              </h3>
              <div className="space-y-2">
                {circles?.map((circle) =>
                  <button
                    key={circle?.id}
                    onClick={(e) => {
                      handleFilterChange(circle?.id, e);
                      setIsMobileDrawerOpen(false);
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all min-h-[44px] ${activeCircle === circle?.id ?
                      'bg-[#C5A059]/15 text-[#C5A059]' :
                      'text-[#2C2B29] hover:bg-[#C5A059]/10'}`
                    }
                    style={{ fontFamily: 'Amiri, serif' }}>
                    <div className="flex items-center justify-center w-10 h-10 flex-shrink-0">
                      {circle?.id === 'sufism' ?
                        <img
                          src="/assets/images/Screenshot_2026-01-22_223436-removebg-preview-1769116472162.png"
                          alt="دائرة الدائرة"
                          className="w-5 h-5 object-contain opacity-90"
                          style={{
                            filter: activeCircle === circle?.id ?
                              'grayscale(0%) contrast(125%)' :
                              'grayscale(100%) contrast(125%)'
                          }} /> :
                        circle?.id === 'soul' ?
                          <img
                            src="/assets/images/Screenshot_2026-01-22_223930-removebg-preview_1_-1769115911581.png"
                            alt="دائرة النفس"
                            className="w-7 h-7 object-contain opacity-100"
                            style={{
                              filter: activeCircle === circle?.id ?
                                'grayscale(0%) contrast(125%)' :
                                'grayscale(100%) contrast(125%)'
                            }} /> :
                          circle?.id === 'sound' ?
                            <img
                              src="/assets/images/vecteezy_black-sound-wave-icon-with-simple-and-modern-design_47445215-1769116873745.png"
                              alt="دائرة الصوت"
                              className="w-10 h-10 object-contain opacity-100"
                              style={{
                                filter: activeCircle === circle?.id ?
                                  'grayscale(0%) contrast(125%)' :
                                  'grayscale(100%) contrast(125%)'
                              }} /> :
                            circle?.id === 'reflections' ?
                              <img
                                src="/assets/images/Screenshot_2026-01-22_232822-removebg-preview-1769117314572.png"
                                alt="دائرة الرحلة"
                                className="w-6 h-6 object-contain opacity-90"
                                style={{
                                  filter: activeCircle === circle?.id ?
                                    'grayscale(0%) contrast(125%)' :
                                    'grayscale(100%) contrast(125%)'
                                }} /> :
                              circle?.id === 'language' ?
                                <img
                                  src="/assets/images/Screenshot_2026-01-22_233414-removebg-preview-1769117612785.png"
                                  alt="دائرة اللسان"
                                  className="w-7 h-7 object-contain opacity-100"
                                  style={{
                                    filter: activeCircle === circle?.id ?
                                      'grayscale(0%) contrast(125%)' :
                                      'grayscale(100%) contrast(125%)'
                                  }} /> :
                                circle?.id === 'heritage' ?
                                  <img
                                    src="/assets/images/Screenshot_2026-01-23_003258-removebg-preview-1769121221939.png"
                                    alt="دائرة التراث"
                                    className="w-9 h-9 object-contain opacity-100"
                                    style={{
                                      filter: activeCircle === circle?.id ?
                                        'grayscale(0%) contrast(125%)' :
                                        'grayscale(100%) contrast(125%)'
                                    }} /> :
                                  circle?.id === 'arts' ?
                                    <img
                                      src="/assets/images/images-removebg-preview-1769118454586.png"
                                      alt="دائرة الفنون"
                                      className="w-7 h-7 object-contain opacity-100"
                                      style={{
                                        filter: activeCircle === circle?.id ?
                                          'grayscale(0%) contrast(125%)' :
                                          'grayscale(100%) contrast(125%)'
                                      }} /> :

                                    <Icon
                                      name={circle?.icon}
                                      size={20}
                                      color={activeCircle === circle?.id ? '#C5A059' : circle?.color}
                                      style={{
                                        filter: activeCircle === circle?.id ?
                                          'grayscale(0%) contrast(125%) opacity(0.9)' :
                                          'grayscale(100%) contrast(125%) opacity(0.9)'
                                      }} />
                      }
                    </div>
                    <span className="flex-1 text-right text-base">{circle?.name}</span>
                  </button>
                )}
              </div>
            </div>

            {/* Discussion Circles Button */}
            <div className="px-6 py-4">
              <button
                onClick={() => {
                  navigate('/discussions-feed');
                  setIsMobileDrawerOpen(false);
                }}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all min-h-[44px] bg-[#C5A059]/10 text-[#C5A059] hover:bg-[#C5A059]/20"
                style={{ fontFamily: 'Amiri, serif' }}>
                <div className="flex items-center justify-center w-10 h-10 flex-shrink-0">
                  <Icon name="Users" size={20} color="#C5A059" />
                </div>
                <span className="flex-1 text-right text-base">حلقات نقاشية</span>
              </button>
            </div>

            <div className="px-6 py-6 mt-auto">
              <button
                onClick={() => navigate('/creator-studio')}
                className="w-full bg-[#C5A059] text-white py-4 rounded-full font-medium text-lg min-h-[44px]"
                style={{ fontFamily: 'Amiri, serif' }}>
                اترك أثراً
              </button>
            </div>
          </div>
        </div>
      }
      <main className="pt-16 lg:pt-20">
        {/* Hero Section */}
        <section className="relative pt-16 md:pt-24 lg:pt-32 pb-6 md:pb-8 lg:pb-10 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-[var(--color-accent)]/5 to-transparent" />
          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 text-center relative z-10 pt-8">
            <div className="relative inline-flex items-center justify-center w-40 h-40 mb-2">
              {/* Three perfectly centered concentric circles - gentle unified pulse */}
              <div
                className="absolute rounded-full border border-[#C5A059]/60 animate-pulse-ring-subtle"
                style={{
                  width: 128,
                  height: 128,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
              <div
                className="absolute rounded-full border border-[#C5A059]/75 animate-pulse-ring-subtle"
                style={{
                  width: 88,
                  height: 88,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  animationDelay: '0.2s',
                }}
              />
              <div
                className="absolute rounded-full border-2 border-[#C5A059] animate-pulse-ring-subtle"
                style={{
                  width: 48,
                  height: 48,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  animationDelay: '0.4s',
                }}
              />
              <div className="relative z-10 w-3 h-3 rounded-full bg-[#C5A059]" />
            </div>
            <h1 className="md:text-5xl lg:text-6xl font-heading font-bold mb-6 text-[64px] text-[rgba(197,160,89,1)]">
              عن دوائر
            </h1>
            <p className="md:text-xl text-[var(--color-muted-foreground)] font-body max-w-3xl mx-auto text-xl">
              فضاء حر للإبداع العربي، حيث تتلاقى الأفكار وتتشكل الدوائر الثقافية
            </p>
          </div>
        </section>

        {/* Features Grid */}
        <section className="py-6 md:py-8 lg:py-10">
          <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="flex flex-col gap-16 md:gap-20 lg:gap-24">
              {features?.map((feature, index) => {
                const isEven = index % 2 === 0;
                return (
                  <div
                    key={feature?.id}
                    className={`flex flex-col md:flex-row items-center gap-8 md:gap-12 lg:gap-16 ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'}`
                    }>

                    {/* Text Block */}
                    <div className={`flex-1 text-center md:text-right ${isEven ? 'md:text-left' : 'md:text-right'}`
                    }>
                      <h3
                        className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-[rgba(44,44,44,1)]"
                        style={{ fontFamily: 'Aref Ruqaa, serif', color: '#2c2c2c' }}>

                        {feature?.title}
                      </h3>
                      <p
                        className="text-base md:text-lg lg:text-xl leading-relaxed"
                        style={{ fontFamily: 'Amiri, serif', color: '#5A5A5A' }}>

                        {feature?.description}
                      </p>
                    </div>

                    {/* Floating Circle Orb */}
                    <div className="flex-shrink-0">
                      <div
                        className="w-40 h-40 md:w-48 md:h-48 rounded-full bg-[#F9F7F2] border border-[#C5A059] flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow duration-300"
                        style={{
                          animation: 'float 8s ease-in-out infinite',
                          animationDelay: `${index * 2}s`
                        }}>
                        <Icon name={feature?.icon} size={64} color="#C5A059" />
                      </div>
                    </div>
                  </div>);

              })}
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 md:py-20 lg:py-24">
          <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 text-center">
            <div className="bg-gradient-to-br from-[var(--color-accent)]/10 to-[var(--color-primary)]/10 rounded-3xl p-10 md:p-12 lg:p-16">
              <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-foreground)] mb-4 font-heading">كُن حلقةً في السلسلة

              </h2>
              <p className="text-lg md:text-xl text-[var(--color-muted-foreground)] mb-8 font-body">
                شارك صوتك مع مجتمع ثقافي متميز
              </p>
              <Button
                variant="default"
                onClick={() => {
                  if (isAuthenticated) {
                    navigate('/creator-studio');
                  } else {
                    navigate('/signup', { state: { directToForm: true } });
                  }
                }}
                className="rounded-full px-8 py-3 shadow-warm"
                style={{
                  background: 'linear-gradient(135deg, #D4AF37 0%, #F4E5B8 100%)',
                  color: 'white',
                  border: 'none'
                }}>
                اترك أثرًا
              </Button>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[var(--color-card)] border-t border-[var(--color-border)] py-8 md:py-10 lg:py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm md:text-base text-[var(--color-muted-foreground)] font-body">
              © {new Date()?.getFullYear()} <span className="font-bold text-[var(--color-foreground)]">دوائر</span>. جميع حقوق النشر محفوظة لأصحابها.
            </p>
          </div>
        </div>
      </footer>
    </div>);

};

export default AboutDawaaer;
